module.exports = __webpack_public_path__ + "static/media/Keno_BG_Music.e52be8b5.mp3";